import * as React from 'react';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { ExportFileStatus } from './types';
import { ExportStatus } from './types-store';
import styles from '../../my-downloads.scss';
import { PromptConfirmationModal } from 'ui/common/prompt-confirmation/prompt-confirmation-modal';
import { ElementLoader } from 'ui';
import { getFileExtension } from 'app/area/my-downloads/extensions';
import { DEFAULT_DATE_FORMAT } from 'app/infrastructure/data/date';

export interface ExportsDownloadItemProps extends ExportStatus {
  downloadCaseExportPackage: (exportId: string, fileExtension: string) => void;
}

export type ExportsContainerProps = ExportsDownloadItemProps & DefaultContainerProps;

export class ExportsViewItem extends React.Component<ExportsContainerProps, any> {
  private dateFormatter = (date: string) => {
    const parsedDate = new Date(date);
    const formattedDate = this.props.intl.formatDate(parsedDate, DEFAULT_DATE_FORMAT);
    const formattedTime = this.props.intl.formatTime(parsedDate);
    return formattedDate + ' ' + formattedTime;
  };

  private onDownload = () => {
    const { exportId, contentType } = this.props;
    this.props.downloadCaseExportPackage(exportId, getFileExtension(contentType));
  };

  public render() {
    const { download, exportId, status, comments, numberOfCases, exportStartedAt, contentType, translation } = this.props;
    const isPending = status && (status.v <= [ExportFileStatus.pending]);
    const fileExtension = getFileExtension(contentType);

    const buttonBody = <>
      {!!isPending && <div className={styles.progress}><div className={styles.progressBar}/></div>}

      <div className={styles.myDownloadsTileExtWrapper}>
        <div className={styles.fileExtention}>{fileExtension ? '.' + fileExtension : ''}</div>
      </div>
      <div className={styles.myDownloadsDownloadContent}>
        <h2 className={styles.myDownloadsDownloadItemTitle}>
          {comments}
        </h2>
        <ul className={styles.myDownloadsDownloadMetadata}>
          <li>{status.d}</li>
          {numberOfCases && <li>
            {numberOfCases + ' '}
            {numberOfCases > 1 ?
              (translation.exports_number_of_cases_multi) : (translation.exports_number_of_cases_single)}
          </li>}
          <li>
            {this.dateFormatter(exportStartedAt).trim()}
          </li>
        </ul>
      </div>
    </>;

    const button = <button
      type="button"
      className={styles.myDownloadsDownloadItem}>
      <div className={styles.downloadItemBody}>
        {download && exportId && download.exportId === exportId && download.fetching
          ? <ElementLoader /> : buttonBody}
      </div>
    </button>;

    return status && status.v === ExportFileStatus.completed ? <PromptConfirmationModal
      title={translation.export_download_title}
      description={translation.export_download_description}
      continueText={translation.export_download_submit}
      cancelText={translation.export_download_cancel}
      onContinue={this.onDownload}>
      {button}
    </PromptConfirmationModal> : button;
  }
}
